// extracted by mini-css-extract-plugin
export default {"formError":"styles_formError__DVP5v"};